<template>
  <div class="div-calendar">
    <b-calendar
      ref="calendar"
      class="w-100 calendar"
      v-model="day"
      weekdayHeaderFormat="narrow"
      :date-info-fn="dateClass"
      locale="pt-BR"
      :hide-header="false"
      label-help=""
      no-highlight-today
      @input="v => $emit('update', v)"
      @selected="dateSelected"
    >
    </b-calendar>
    <div class="outside" @click="close()"></div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data: () => ({
    day: null,
  }),

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.day = this.value;
  },

  methods: {
    close() {
      this.$emit('close');
    },

    dateClass(ymd, date) {
      const day = moment(date);
      if (day.startOf('day') >= moment(this.day).startOf('week')
        && day.endOf('day') <= moment(this.day).endOf('week')) {
        return 'active-date';
      }
      return '';
    },

    dateSelected() {
      this.close();
    },
  },

};
</script>

<style>
.button--green {
  color: #00daae;
  border-style: solid;
  border-radius: 0.6rem;
  border-width: 0.15rem;
  padding: 0.4rem;
}
.button--green.unselected {
  opacity: 0.3;
}
.button--green.selected {
  background-color: rgba(0, 218, 174, 0.25) !important;
}
.button--green:hover {
  background-color: #00daae !important;
  color: white !important;
}
.button--green .icon {
  fill: #00daae;
  margin: 0;
}

.div-calendar {
  position: absolute;
  z-index: 999;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.calendar {
  margin: 1rem;
}

.calendar .form-control{
  border-width: 0;
}
.calendar .active {
  background-color: #00daae !important;
  border-radius: 5px !important;
}

.active-date {
  background-color:  rgba(0, 218, 174, 0.25);
}

.calendar .btn-outline-secondary {
  color: #00daae;
}
.calendar .b-calendar-grid-caption.font-weight-bold {
  color: #00daae;
  font-weight: 400 !important;
}

.outside {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: -1;
}
</style>
